const SOCIAL_PROFILES = {
  linked_in: 'LinkedIn Profile Link',
}

export default SOCIAL_PROFILES
